module.exports = __webpack_public_path__ + "img/binity-logo--white.f4cd811c.svg";